import { Dialog } from '../../../components/Dialog';

export function LeavePageWarningDialog(props: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  const { isOpen, onConfirm, onClose } = props;

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Leave this page?"
      description="Leaving this session will end the current session and generate a summary of strengths, areas for improvement, and recommendations."
      confirmText="Leave"
    />
  );
}
